import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import api from "../../api/axiosConfig";
import { format } from "date-fns";
import { useAuth } from "../Authentication/AuthContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../TimeSheet/TimeSheetTable.css";
import { ProjectContext } from "../../App";
import { useRolePermissions } from "../Settings/RoleContext";
import { parseISO } from "date-fns";
import { ToastContainer, toast } from "react-toastify";
import socket from "../../socket";

const AddTimeSheet = ({ refresh: refreshTrigger, onTimesheetAdded }) => {
  const { dialBoxopen, addTimesheetOpen, setAddTimesheetOpen } =
    useContext(ProjectContext);
  const { hasPermission } = useRolePermissions();
  const [timesheets, setTimesheets] = useState([]);
  const { userDetails } = useAuth();
  const userId = userDetails.id;
  const { projectId } = useParams();
  const [loading, setLoading] = useState(true);
  const [taskTemplate, setTaskTemplate] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchEstTerm, setSearchEstTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showEstDropdown, setShowEstDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [timesheetSettings, setTimesheetSettings] = useState([]);
  const [users, setUsers] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [estimates, setEstimates] = useState([]);
  const [filteredEstimates, setFilteredEstimates] = useState([]);
  const [selectedEstimateName, setSelectedEstimateName] = useState("");
  const [phases, setPhases] = useState([]);
  const [logCategory, setLogCategories] = useState([]);
  const [selectedTaskTemplate, setSelectedTaskTemplate] = useState("");
  const [taskTemplateName, setTaskTemplateName] = useState("");
  const [selectedVariationDetails, setSelectedVariationDetails] = useState("");
  const [hours, setHours] = useState("");
  useEffect(() => {
    if (!taskTemplateName) return; // ✅ Prevents "Cannot read properties of undefined"

    let hours;
    if (taskTemplateName.includes("Design")) {
      hours = selectedVariationDetails?.design;
    } else if (taskTemplateName.includes("Detailing")) {
      hours = selectedVariationDetails?.detailing;
    }

    setHours(hours);
  }, [taskTemplateName, selectedVariationDetails]);

  useEffect(() => {
    const name = taskTemplate.find(
      (t) => Number(t.id) === Number(selectedTaskTemplate)
    );
    setTaskTemplateName(name?.name);
  }, [taskTemplate, selectedTaskTemplate]);

  const [user, setUser] = useState("");
  const [timeEntryMethod, setTimeEntryMethod] = useState("duration");
  const [durationHours, setDurationHours] = useState("");
  const [notes, setNotes] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedFromTime, setSelectedFromTime] = useState(null);
  const [selectedToTime, setSelectedToTime] = useState(null);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [selectedProjectStartDate, setSelectedProjectStartDate] = useState("");
  const [selectedProjectEndDate, setSelectedProjectEndDate] = useState("");
  const [selectedPhaseStartDate, setSelectedPhaseStartDate] = useState("");
  const [selectedPhaseEndDate, setSelectedPhaseEndDate] = useState("");
  const [selectedPhase, setSelectedPhase] = useState("");
  const [selectedPhaseId, setSelectedPhaseId] = useState(null);
  const [selectedLogCategory, setSelectedLogCategory] = useState("");
  const [selectedTasks, setSelectedTasks] = useState("");
  const [selectedEstimate, setSelectedEstimate] = useState("");
  const [selectedTasksStartDate, setSelectedTasksStartDate] = useState("");
  const [selectedTasksDueDate, setSelectedTasksDueDate] = useState("");
  const [error, setError] = useState(null);
  const [dropdownVariationOptions, setDropdownVariationOptions] = useState([]);
  const [dropdownIssueOptions, setDropdownIssueOptions] = useState([]);
  const [selectedVariation, setSelectedVariation] = useState("");
  const [selectedIssue, setSelectedIssue] = useState("");
  const [usersId, setUsersId] = useState("");
  const [userExistingHoursInMinutes, setUserExistingHoursInMinutes] =
    useState("");
  const [tsCategory, setTsCategory] = useState("Project");
  const [isBillable, setIsBillable] = useState(
    tsCategory === "Project" ? "Yes" : "No"
  );
  const [isContainsHours, setIsContainHours] = useState(false);
  const userID = userDetails.id;
  const changeTsCategory = (c) => {
    setIsContainHours(false);
    setTsCategory(c);
    setUsersId([]);
    setSelectedPhase([]);
    setSelectedLogCategory([]);
    setSelectedTasks([]);
    setSelectedTaskTemplate([]);
    setDurationHours([]);
    setSelectedDate(null);
    setSelectedProject("");
    setSelectedProjectName("");
    setShowDropdown(false);
    setSelectedIssue("");
    setSelectedVariation("");
    setSelectedEstimate("");
    setHours("");
    setTaskTemplateName("");
    setSelectedVariationDetails([]);
    setSelectedTaskTemplate("");
  };
  useEffect(() => {
    const voDetails = dropdownVariationOptions.find(
      (v) => Number(v.id) === Number(selectedVariation)
    );
    setSelectedVariationDetails(voDetails);
  }, [dropdownVariationOptions, selectedVariation]);
  useEffect(() => {
    socket.on("variation updated", (variationId, updateFields, values) => {
      setDropdownVariationOptions((prevVariations) =>
        prevVariations.map((variation) =>
          variation.id === Number(variationId)
            ? {
                ...variation,
                ...Object.fromEntries(
                  updateFields.map((field, index) => [
                    field.replace(" = ?", ""),
                    values[index],
                  ])
                ), // Convert field-value pairs
              }
            : variation
        )
      );
    });

    return () => {
      socket.off("variation updated");
    };
  }, []);

  useEffect(() => {
    if (selectedTasks && tasks.length > 0) {
      const task = tasks.find((t) => t.id === Number(selectedTasks));

      if (task) {
        setSelectedTasksDueDate(task.due_date !== null ? task.due_date : 0);
        setSelectedTasksStartDate(
          task.start_date !== null ? task.start_date : 0
        );
      } else {
        console.warn("No task found for the selected ID:", selectedTasks);
        setSelectedTasksDueDate(0); // Default value or handle as per your needs
        setSelectedTasksStartDate(0);
      }
    }
  }, [selectedTasks, tasks]);
  function normalizePlannedHours(input) {
    // If input is a decimal (e.g., "1.5"), convert it to HH:MM format
    if (/^[0-9]+([.][0-9]+)?$/.test(input)) {
      const hours = Math.floor(parseFloat(input));
      const minutes = Math.round((parseFloat(input) - hours) * 60);
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    }

    // If input is in HH:MM format, return it directly
    if (/^[0-9]+:[0-5][0-9]$/.test(input)) {
      return input;
    }

    // If input is a whole number, treat it as hours
    if (/^[0-9]+$/.test(input)) {
      return `${parseInt(input, 10)}:00`;
    }

    // For invalid formats, return an empty string
    return "";
  }

  useEffect(() => {
    const calculateExistingHours = async (user, selectedDate) => {
      try {
        const response = await api.get(
          `/api/timesheets/${user}/${selectedDate.toLocaleDateString("en-CA")}`
        );
        const userTimesheets = response.data;
        let totalMinutes = 0;
        userTimesheets.forEach((timesheet) => {
          const [hours, minutes] = timesheet.duration.split(":").map(Number);
          if (!isNaN(hours) && !isNaN(minutes)) {
            totalMinutes += hours * 60 + minutes;
          }
        });

        let res = (8 * 60 - totalMinutes) / 60; // Convert to hours
        res = normalizePlannedHours(res);

        setUserExistingHoursInMinutes(res); // Update state once
      } catch (error) {
        console.error("Error fetching existing timesheets:", error);
      }
    };

    if (user && selectedDate !== null) {
      calculateExistingHours(user, selectedDate);
    }
  }, [user, selectedDate]);

  const onClosePopUp = () => {
    setSelectedPhase([]);
    setSelectedLogCategory([]);
    setSelectedTasks([]);
    setSelectedTaskTemplate([]);
    setIsBillable([]);
    setDurationHours([]);
    setSelectedDate(null);
    setUser([]);
    setAddTimesheetOpen(false);
    setUserExistingHoursInMinutes("");
    setSelectedIssue("");
    setSelectedVariation("");
    setHours("");
    setTaskTemplateName("");
    setSelectedVariationDetails([]);
    setSelectedTaskTemplate("");
    setSelectedEstimateName("");
    setSelectedEstimate("");
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleFromTime = (timeFrom) => {
    setSelectedFromTime(timeFrom);
  };

  const handleToTime = (timeTo) => {
    setSelectedToTime(timeTo);
  };

  const handlFetchUserId = (e) => {
    setUsersId(e.target.value);
    setUser(e.target.value);
    setSelectedPhase([]);
    setSelectedLogCategory([]);
    setSelectedTasks([]);
    setSelectedTaskTemplate([]);
    setIsBillable([]);
    setDurationHours([]);
    setSelectedDate(null);
    setSelectedProject("");
    setSelectedProjectName("");
    setShowDropdown(false);
    setSelectedIssue("");
    setSelectedVariation("");
    setHours("");
    setTaskTemplateName("");
    setSelectedVariationDetails([]);
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown and profile
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) //&&
      // profileRef.current &&  !profileRef.current.contains(event.target)
    ) {
      setShowDropdown(false); // Close the dropdown
      setShowEstDropdown(false);
    }
  };

  // Add event listener for clicks outside the component
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(e.target.value);
    setSelectedProjectName("");

    const filtered = projects.filter((project) => {
      const name = project.name || ""; // Fallback to an empty string
      const projectno = project.projectno || ""; // Fallback to an empty string
      const displayName = project.displayName || ""; // Fallback to an empty string

      return (
        name.toLowerCase().includes(searchValue) ||
        projectno.toLowerCase().includes(searchValue) ||
        displayName.toLowerCase().includes(searchValue)
      );
    });

    setFilteredProjects(filtered);
    setShowDropdown(true); // Show the dropdown when the user types
  };

  const handleFocus = () => {
    setSearchTerm(""); // Reset the search term to show all projects
    setFilteredProjects(projects); // Show all projects when focusing on the input
    setShowDropdown(true); // Show the dropdown
  };
  const handleEstSearchChange = (e) => {
    const searchEstValue = e.target.value.toLowerCase();
    setSearchEstTerm(e.target.value);
    setSelectedEstimateName("");

    const filtered = estimates.filter((estimate) => {
      const name = estimate.projectname || "";
      const projectno = estimate.estimateno || "";

      return (
        name.toLowerCase().includes(searchEstValue) ||
        projectno.toLowerCase().includes(searchEstValue)
      );
    });

    setFilteredEstimates(filtered);
    setShowEstDropdown(true); // Show the dropdown when the user types
  };
  const handleEstFocus = () => {
    setSearchEstTerm("");
    setFilteredEstimates(estimates);
    setShowEstDropdown(true); // Show the dropdown
  };

  //update userId for user login
  useEffect(() => {
    if (userDetails.role !== "Administrator") {
      setUser(userDetails.id); // Set the current user's ID in state if not admin
    }
  }, [userDetails, setUser]);

  const handleTaskTemplateChange = (event) => {
    setSelectedTaskTemplate(event.target.value);
    setSelectedTasks([]);
    setSelectedDate(null);
  };

  const handlelogcategoryChanger = (e) => {
    setSelectedLogCategory(e.target.value);
    setSelectedTaskTemplate([]);
    setSelectedTasks([]);
    setTasks([]);
    setSelectedDate(null);
    setSelectedIssue("");
    setSelectedVariation("");
  };

  const handleRadioChange = (event) => {
    setIsBillable(event.target.value);
  };

  //fetch phase changes
  const handlePhaseChange = (event) => {
    const phaseId = event.target.value;
    setSelectedPhase(phaseId);
    const selectedPhaseDetails = phases.phases.find((ph) => {
      return ph.id === Number(phaseId);
    });
    setSelectedPhaseStartDate(selectedPhaseDetails.start_date);
    setSelectedPhaseEndDate(selectedPhaseDetails.end_date);
    const phase = selectedProject?.phases?.find(
      (p) => p.id === parseInt(phaseId)
    );
    if (phase) {
      setSelectedPhaseId(phase.id);
    } else {
      setSelectedPhaseId(null);
    }
    // Clear selected task template and tasks when phase changes
    setSelectedLogCategory([]);
    setSelectedTaskTemplate("");
    setTasks([]);
  };
  //fetch users, category , tasktemplate
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, logCategories, timelogRes] = await Promise.all([
          api.get(`/api/users`),
          api.get("/api/categories"),
          api.get("/api/timesheet/settings"),
        ]);
        const activeUsers = usersRes.data.filter(
          (member) => member.status !== "Inactive"
        );
        setUsers(activeUsers);
        setTimesheetSettings(
          timelogRes.data.find((t) => t.settings === "log_period").value
        );
        setLogCategories(logCategories.data);

        if (selectedPhase.length > 0) {
          const taskTemplatesRes = await api.get(
            `/api/phase/${selectedPhase}/taskTemplates`
          );
          setTaskTemplate(taskTemplatesRes.data);
        } else {
          setTaskTemplate([]); // Clear task templates if no phase is selected
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedPhase, projectId]); // Include selectedPhase as a dependency

  //fetch project details
  useEffect(() => {
    const fetchProject = async () => {
      const id =
        userDetails.role_name === "Administrator" ||
        userDetails.role_name === "Super Admin"
          ? usersId
          : userID;

      try {
        const endpoint = `/api/projectlistdata/${id}`;
        const res = await api.get(endpoint);
        const filteredProject = res.data.filter(
          (project) => project.activestatus === 1
        );
        setProjects(filteredProject);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    const id =
      userDetails.role_name === "Administrator" ||
      userDetails.role_name === "Super Admin"
        ? usersId
        : userID;
    if (id) {
      fetchProject();
    }
  }, [userDetails.role, userID, usersId]);

  useEffect(() => {
    if (selectedTaskTemplate.length > 0) {
      const fetchTasks = async () => {
        try {
          const taskUser =
            userDetails.role_name === "Administrator" ||
            userDetails.role_name === "Super Admin"
              ? user
              : userId;
          const res = await api.get(
            `/api/tasks-timesheet/${selectedTaskTemplate}/${taskUser}`
          );
          setTasks(res.data);
        } catch (error) {
          console.error(error);
        }
      };
      fetchTasks();
    }
    if (tsCategory !== "Project") {
      const templateId = tsCategory === "NonProductive" ? 6 : 4;
      const fetchTasks = async () => {
        try {
          const res = await api.get(`/api/tasks-timesheet/${templateId}/tasks`);
          setTasks(res.data);
        } catch (error) {
          console.error(error);
        }
      };
      fetchTasks();
    }
    if (tsCategory === "Estimate") {
      const fetchEst = async () => {
        try {
          const res = await api.get(`/api/estimates-timesheet`);
          setEstimates(res.data);
        } catch (error) {
          console.error(error);
        }
      };
      fetchEst();
    }
    setIsBillable(tsCategory === "Project" ? "Yes" : "No");
  }, [selectedTaskTemplate, tsCategory]);

  const handleProjectChange = (e) => {
    setSearchTerm("");
    setShowDropdown(false);
    setSelectedProject(e.target.value); // Sets selected project
    fetchPhases(e.target.value);
    setSelectedPhase(""); // Reset phase when project changes
    setSelectedPhase([]);
    setSelectedLogCategory([]);
    setSelectedTasks([]);
    setSelectedTaskTemplate([]);
    setIsBillable([]);
    setDurationHours([]);
    setSelectedDate(null);
    setTasks([]);
    setSelectedIssue("");
    setSelectedVariation("");
  };
  const handleEstimateChange = (e) => {
    setSearchEstTerm("");
    setShowEstDropdown(false);
    setSelectedEstimate(e.target.value); // Sets selected project
    setSelectedTasks([]);
    setIsBillable([]);
    setDurationHours([]);
    setSelectedDate(null);
  };

  useEffect(() => {
    if (selectedProject) {
      const project = projects.find((p) => p.id === Number(selectedProject));
      setSelectedProjectName(`${project.projectno}-${project.name}`);
      if (project) {
        setSelectedProjectStartDate(parseISO(project.start_date));
        setSelectedProjectEndDate(parseISO(project.end_date));
      }
    }
  }, [selectedProject, projects]);
  useEffect(() => {
    if (selectedEstimate) {
      const estimate = estimates.find((e) => e.id === Number(selectedEstimate));
      setSelectedEstimateName(
        `${estimate?.estimationno}-${estimate?.projectname}`
      );
    }
  }, [selectedEstimate, estimates]);

  useEffect(() => {
    if (phases?.id === Number(selectedProject)) {
      const selectedProjectData = phases;
      const overallBudgetHours = selectedProjectData?.overall_budget_hours;
      const customer = selectedProjectData?.customer_name;
      const isContainsHours =
        customer !== "MSES Group Ltd" && overallBudgetHours === "00:00";
      setIsContainHours(isContainsHours);
    }
  }, [selectedProject, phases]);

  //fetch phases based on project ID

  const fetchPhases = async (selectedProject) => {
    if (selectedProject) {
      try {
        const res = await api.get(`/api/project/${selectedProject}/phases`);
        setPhases(res.data);
      } catch (error) {
        console.error("Error fetching phases:", error);
      }
    }
  };

  useEffect(() => {
    fetchPhases(selectedProject);
  }, [selectedProject]);

  // general || variation || issue header
  let headingText;
  switch (selectedLogCategory) {
    case "1":
      headingText = "General";
      break;
    case "2":
      headingText = "Variations";
      break;
    case "4":
      headingText = "Issues";
      break;
    default:
      headingText = "Title";
  }

  //fetch variation and issue dropdown options
  useEffect(() => {
    let fetchData;

    switch (headingText) {
      case "Variations":
        fetchData = async () => {
          try {
            const res = await api.get(`/api/phase/${selectedPhase}/variations`);
            const filterDate = res.data;
            setDropdownVariationOptions(filterDate);
          } catch (error) {
            console.error(error);
          }
        };
        break;
      case "Issues":
        fetchData = async () => {
          try {
            const res = await api.get(`/api/phase/${selectedPhase}/issues`);

            setDropdownIssueOptions(res.data);
          } catch (error) {
            console.error(error);
          }
        };
        break;
      default:
        setDropdownVariationOptions([]);
        setDropdownIssueOptions([]);
    }

    if (fetchData) {
      fetchData();
    }
  }, [headingText, selectedPhase]);
  //dropdown options for variation and issue
  const dropdownOptions =
    headingText === "Variations"
      ? dropdownVariationOptions.filter((v) => v.variation_status !== "Waiting")
      : dropdownIssueOptions;
  const selectedOption =
    headingText === "Variations" ? selectedVariation : selectedIssue;

  //add new timesheet
  const handleAddTimesheet = async () => {
    setLoading(true);
    if (
      tsCategory === "project" &&
      (!user ||
        !selectedDate ||
        (!selectedFromTime && timeEntryMethod === "from-to") ||
        (!selectedToTime && timeEntryMethod === "from-to") ||
        (!durationHours && timeEntryMethod === "duration") ||
        !selectedProject ||
        !selectedPhase ||
        durationHours === "0:00" ||
        selectedTasks.length === 0 ||
        (isBillable !== "Yes" && isBillable !== "No") ||
        (selectedLogCategory !== "1" && !(selectedVariation || selectedIssue)))
    ) {
      toast.error(
        durationHours === "0:00"
          ? "Enter valid duration hours"
          : "Please fill in all required details.",
        {
          position: "bottom-center",
          autoClose: 2000,
        }
      );

      return; // Stop the function execution if any details are missing
    }

    // Step 1: Fetch existing hours for the user on the selected date
    let existingHoursInMinutes = 0;
    try {
      const response = await api.get(
        `/api/timesheets/${user}/${selectedDate.toLocaleDateString("en-CA")}`
      );
      const userTimesheets = response.data;

      // Calculate the total duration in minutes from the user's existing timesheets on this date
      userTimesheets.forEach((timesheet) => {
        const [hours, minutes] = timesheet.duration.split(":").map(Number);
        existingHoursInMinutes += hours * 60 + minutes;
      });
      // window.location.reload();
    } catch (error) {
      console.error("Error fetching existing timesheets:", error);

      return;
    }

    // Step 2: Calculate the duration of the new entry
    let currentEntryDurationInMinutes = 0;
    if (timeEntryMethod === "from-to") {
      const fromTimeParts = selectedFromTime
        .toLocaleTimeString("en-CA", { hour12: false })
        .split(":")
        .map(Number);
      const toTimeParts = selectedToTime
        .toLocaleTimeString("en-CA", { hour12: false })
        .split(":")
        .map(Number);

      const fromTimeInMinutes = fromTimeParts[0] * 60 + fromTimeParts[1];
      const toTimeInMinutes = toTimeParts[0] * 60 + toTimeParts[1];

      currentEntryDurationInMinutes = toTimeInMinutes - fromTimeInMinutes;
      if (currentEntryDurationInMinutes < 0) {
        currentEntryDurationInMinutes += 24 * 60; // Adjust for overnight shifts
      }
    } else if (timeEntryMethod === "duration") {
      const [hours, minutes] = durationHours.split(":").map(Number);
      currentEntryDurationInMinutes = hours * 60 + minutes;
    }

    // Step 3: Compare the total hours (existing + current entry) with the limit of 8 hours (480 minutes)
    const totalMinutesForDay =
      existingHoursInMinutes + currentEntryDurationInMinutes;
    const totalHoursForDay = totalMinutesForDay / 60;

    if (totalHoursForDay > 8) {
      toast.error(
        `You cannot log more than 8 hours in a day. Your current total would be ${totalHoursForDay.toFixed(
          2
        )} hours.`,
        {
          position: "bottom-center",
          autoClose: 2000,
        }
      );
      setError(
        `You cannot log more than 8 hours in a day. Your current total would be ${totalHoursForDay.toFixed(
          2
        )} hours.`
      );
      setTimeout(() => {}, 2000);
      return; // Stop function if the total exceeds 8 hours
    }

    // Step 4: Proceed to add the timesheet if the total hours are <= 8
    const title = tasks.find((task) => task.id === Number(selectedTasks));
    const titleName =
      title && tsCategory === "Project" ? title.phase_taskname : title.name;
    let adjustedTimesheet;
    tsCategory === "Project"
      ? (adjustedTimesheet = {
          user_id: user,
          date: selectedDate.toLocaleDateString("en-CA"),
          project_id: selectedProject,
          phase_id: selectedPhase,
          log_category: selectedLogCategory,
          task_id: Number(selectedTasks),
          variation_id: selectedVariation || null,
          issue_id: selectedIssue || null,
          billable: isBillable === "Yes" ? "1" : "0",
          logtitle: titleName,
          duration: "", // Will be set below
          approvalstatus: "Pending",
          notes: notes,
        })
      : tsCategory === "NonProductive"
      ? (adjustedTimesheet = {
          user_id: user,
          date: selectedDate.toLocaleDateString("en-CA"),
          task_id: Number(selectedTasks),
          billable: isBillable === "Yes" ? "1" : "0",
          logtitle: titleName,
          duration: "", // Will be set below
          approvalstatus: "Pending",
          notes: notes,
        })
      : (adjustedTimesheet = {
          user_id: user,
          estimate_id: selectedEstimate,
          date: selectedDate.toLocaleDateString("en-CA"),
          task_id: Number(selectedTasks),
          billable: isBillable === "Yes" ? "1" : "0",
          logtitle: titleName,
          duration: "", // Will be set below
          approvalstatus: "Pending",
          notes: notes,
        });
    if (timeEntryMethod === "from-to") {
      adjustedTimesheet.fromtime = selectedFromTime.toLocaleTimeString(
        "en-CA",
        { hour12: false }
      );
      adjustedTimesheet.totime = selectedToTime.toLocaleTimeString("en-CA", {
        hour12: false,
      });

      // Convert to hh:mm:ss format
      const hours = Math.floor(currentEntryDurationInMinutes / 60);
      const minutes = currentEntryDurationInMinutes % 60;
      const seconds = 0; // Seconds are set to 0 since we only have hours and minutes

      adjustedTimesheet.duration = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    } else if (timeEntryMethod === "duration") {
      // Handle the duration input for duration method
      const [hours, minutes] = durationHours.split(":").map(Number);
      adjustedTimesheet.duration = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:00`; // Store in hh:mm:ss format
    }

    // Step 5: Send the timesheet to the backend
    try {
      const url =
        tsCategory === "Project"
          ? `/api/timesheets/${userId}`
          : tsCategory === "NonProductive"
          ? `/api/nonproductive/timesheets/${userId}`
          : `/api/estimate/timesheets/${userId}`;
      if (onTimesheetAdded) {
        onTimesheetAdded();
      }
      const response = await api.post(url, adjustedTimesheet);
      const data = response.data;
      const newTimesheetWithNames = {
        ...data,
        duration: adjustedTimesheet.duration, // Store the formatted duration
      };

      // Update the local state with the new timesheet
      setTimesheets((prevTimesheets) => {
        const updatedTimesheets = prevTimesheets.map((phase) =>
          phase.phaseId === adjustedTimesheet.phase_id
            ? {
                ...phase,
                timesheets: [...phase.timesheets, newTimesheetWithNames],
              }
            : phase
        );
        return updatedTimesheets;
      });
      setTimeout(() => {
        // window.location.reload();
        setAddTimesheetOpen(false);
      }, 500);
      document.body.classList.remove("no-scroll");
    } catch (error) {
      console.error("Error adding timesheet:", error);
    } finally {
      setLoading(false); // Always stop loading, even on error
      setSelectedPhase([]);
      setSelectedLogCategory([]);
      setSelectedTasks([]);
      setSelectedTaskTemplate([]);
      setIsBillable([]);
      setDurationHours([]);
      setSelectedDate(null);
      setUser([]);
      setUserExistingHoursInMinutes("");
      setSelectedIssue("");
      setSelectedVariation("");
      setUserExistingHoursInMinutes("");
      setHours("");
      setTaskTemplateName("");
      setSelectedVariationDetails([]);
      document.body.classList.remove("no-scroll");
    }
  };

  //set variation or issue details
  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setHours("");
    setTaskTemplateName("");
    setSelectedVariationDetails([]);
    setSelectedTaskTemplate("");
    if (headingText === "Variations") {
      setSelectedVariation(selectedValue);
    } else if (headingText === "Issues") {
      setSelectedIssue(selectedValue);
    }
  };

  const tabCount = hasPermission("estimates", "create") ? 3 : 2;

  const sliderLeft = () => {
    if (tsCategory === "Project") return "0%";
    if (tsCategory === "NonProductive")
      return tabCount === 3 ? "33.33%" : "50%";
    return tabCount === 3 ? "66.66%" : "100%";
  };

  const sliderWidth = () => 100 / tabCount + "%";
  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span className="loading-animation">LOADING...</span>
      </div>
    );
  }

  return (
    <div>
      <ToastContainer />
      {addTimesheetOpen && (
        <div
          className={`timesheet-overlay-add-time-log ${
            dialBoxopen ? "open" : "close"
          }`}
          style={{ zIndex: "15" }}
        >
          <div className="add-timesheet-con">
            <div className="new-time-log-dial">
              <h3
                style={{
                  backgroundColor: "transparent",
                  marginLeft: "15px",
                  marginTop: "5px",
                  fontSize: "15px",
                }}
              >
                Add Time Log
              </h3>
            </div>
            <div className="add-timesheet-category-con">
              <div
                className="tab-slider-ts"
                style={{
                  left: sliderLeft(),
                  width: sliderWidth(),
                }}
              />
              <button
                onClick={() => {
                  changeTsCategory("Project");
                }}
                className={
                  tsCategory === "Project"
                    ? "dial-active-btn active-tab-btn"
                    : "dial-normal-btn normal-tab-btn"
                }
              >
                Project
              </button>
              <button
                onClick={() => {
                  changeTsCategory("NonProductive");
                }}
                className={
                  tsCategory === "NonProductive"
                    ? "dial-active-btn active-tab-btn"
                    : "dial-normal-btn normal-tab-btn"
                }
                style={{ textWrap: "nowrap" }}
              >
                Non-Productive
              </button>
              {hasPermission("estimates", "create") && (
                <button
                  onClick={() => {
                    changeTsCategory("Estimate");
                  }}
                  className={
                    tsCategory === "Estimate"
                      ? "dial-active-btn active-tab-btn"
                      : "dial-normal-btn normal-tab-btn"
                  }
                >
                  Estimate
                </button>
              )}
            </div>
            <div className="scrollable-t-content-dial">
              <h3 className="user-name">User</h3>
              {userDetails.role_name === "Administrator" ||
              userDetails.role_name === "Super Admin" ? (
                <select
                  onChange={handlFetchUserId}
                  value={usersId || ""}
                  className="timesheet-input"
                >
                  <option value="" disabled>
                    Select User
                  </option>
                  {users
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                </select>
              ) : (
                <input
                  type="text"
                  value={userDetails.name} // Automatically select the logged user's name
                  className="timesheet-input"
                  readOnly
                />
              )}
              {tsCategory === "Project" && (
                <>
                  <h3 className="user-name">Project</h3>
                  <input
                    ref={dropdownRef}
                    className="timesheet-d-input"
                    placeholder="Search Projects"
                    value={searchTerm || selectedProjectName || ""}
                    onChange={handleSearchChange}
                    onFocus={handleFocus}
                    onMouseDown={() => handleClickOutside}
                  />
                  {showDropdown &&
                    (showDropdown && filteredProjects?.length > 0 ? (
                      <ul
                        style={{ zIndex: "50" }}
                        ref={dropdownRef}
                        className="project-display-box"
                      >
                        {filteredProjects.map((project) => (
                          <li
                            key={project.id}
                            value={project.id}
                            onClick={(e) => handleProjectChange(e)}
                            onMouseDown={() => handleClickOutside}
                            className="project-dropdown-item"
                          >
                            {project.projectno}-{project.name}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>
                        No Projects available, Contact DC to add project for
                        you.
                      </p>
                    ))}
                </>
              )}
              {selectedProject && tsCategory === "Project" && (
                <>
                  <h3 className="user-name">Phase</h3>
                  <select
                    className="timesheet-input"
                    onChange={handlePhaseChange}
                    value={selectedPhase || ""}
                  >
                    <option value="" disabled>
                      --Select Phase--
                    </option>
                    {phases?.phases?.length > 0 ? (
                      phases.phases.map((phase) => (
                        <option key={phase.id} value={phase.id}>
                          {phase.phaseno}-{phase.title}
                        </option>
                      ))
                    ) : (
                      <option disabled>
                        {loading
                          ? "Loading..."
                          : "No Phases Available, Contact DC to add Phase for this project."}
                      </option>
                    )}
                  </select>
                </>
              )}
              {tsCategory === "Estimate" && (
                <>
                  <h3 className="user-name">Estimate</h3>
                  <input
                    ref={dropdownRef}
                    className="timesheet-d-input"
                    placeholder="Search Estimate"
                    value={searchEstTerm || selectedEstimateName || ""}
                    onChange={handleEstSearchChange}
                    onFocus={handleEstFocus}
                    onMouseDown={() => handleClickOutside}
                  />
                  {showEstDropdown &&
                    (showEstDropdown && filteredEstimates?.length > 0 ? (
                      <ul
                        style={{ zIndex: "50" }}
                        ref={dropdownRef}
                        className="project-display-box"
                      >
                        {filteredEstimates
                          .sort((a, b) => b.id - a.id)
                          .map((project) => (
                            <li
                              key={project.id}
                              value={project.id}
                              onClick={(e) => handleEstimateChange(e)}
                              onMouseDown={() => handleClickOutside}
                              className="project-dropdown-item"
                            >
                              {project.estimationno}-{project.projectname}
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <p>No Estimate available.</p>
                    ))}
                </>
              )}
              {tsCategory === "Project" && (
                <>
                  <h3 className="user-name">Log Category</h3>
                  <select
                    className="timesheet-input"
                    onChange={handlelogcategoryChanger}
                    value={selectedLogCategory || ""}
                  >
                    <option value="" disabled>
                      --Select Category--
                    </option>
                    {logCategory.map((log) => (
                      <option key={log.id} value={log.id}>
                        {log.name.charAt(0).toUpperCase() + log.name.slice(1)}{" "}
                      </option>
                    ))}
                  </select>
                  {headingText !== "General" && headingText !== "Title" && (
                    <div className="Title-container">
                      <h3 className="user-name">{headingText}</h3>
                      <select
                        onChange={handleDropdownChange}
                        value={selectedOption || ""}
                        className="timesheet-input"
                        aria-label={`Select ${headingText}`}
                      >
                        <option value="" disabled>
                          --Select {headingText}--
                        </option>
                        {dropdownOptions?.length > 0 ? (
                          dropdownOptions.map((option) =>
                            headingText === "Variations" ? (
                              <option key={option.id} value={option.id}>
                                {`${option.variationno} - ${option.name}`}
                              </option>
                            ) : headingText === "Issues" ? (
                              <option key={option.id} value={option.id}>
                                {`${option.issue_number} - ${option.name}`}
                              </option>
                            ) : null
                          )
                        ) : (
                          <option disabled>
                            No {headingText} available for this project
                          </option>
                        )}
                      </select>
                    </div>
                  )}
                  <h3 className="user-name">Task Template</h3>
                  <select
                    className="timesheet-input"
                    onChange={handleTaskTemplateChange}
                    value={selectedTaskTemplate || ""}
                  >
                    <option value="" disabled>
                      --Select Task Template--
                    </option>
                    {taskTemplate.length > 0 ? (
                      taskTemplate.map((template) => (
                        <option key={template.id} value={template.id}>
                          {template.name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        There are no Task Template available for you. Contact DC
                        to add Task Template for you.
                      </option>
                    )}
                  </select>
                </>
              )}
              {
                <>
                  <h3 className="user-name">Task</h3>
                  <select
                    onChange={(e) => {
                      setSelectedTasks(e.target.value);
                      setSelectedDate(null);
                    }}
                    value={selectedTasks || ""}
                    className="timesheet-input"
                  >
                    <option value="" disabled>
                      --Select Task--
                    </option>
                    {tasks.length > 0 ? (
                      tasks.map((task) => (
                        <option key={task.id} value={task.id}>
                          {tsCategory === "Project"
                            ? task.phase_taskname
                            : task.name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        There are no tasks available for you. Contact DC to add
                        tasks for you.
                      </option>
                    )}
                  </select>
                </>
              }
              <h3 className="user-name">Date</h3>{" "}
              {tsCategory === "NonProductive" && (
                <p style={{ color: "black", fontSize: "12px" }}>
                  {userExistingHoursInMinutes.length !== 0 &&
                    (userExistingHoursInMinutes &&
                    userExistingHoursInMinutes !== "0:00"
                      ? `Remaining hours for the date ⌛ ${format(
                          new Date(selectedDate),
                          "dd-MM-yyyy"
                        )}: ${userExistingHoursInMinutes} Hrs.`
                      : "You have already booked 8 hours for this date.")}
                </p>
              )}
              <DatePicker
                placeholderText="Select Date"
                className="timesheet-d-input"
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat="dd-MM-yyyy"
                minDate={
                  timesheetSettings &&
                  userDetails.role_name !== "Administrator" &&
                  userDetails.role_name !== "Super Admin"
                    ? new Date(
                        new Date().setDate(
                          new Date().getDate() - timesheetSettings
                        )
                      )
                    : selectedTasksStartDate ||
                      selectedPhaseStartDate ||
                      selectedProjectStartDate
                }
                maxDate={
                  selectedTasksDueDate ||
                  selectedPhaseEndDate ||
                  selectedProjectEndDate
                }
              />
              <h3 className="user-name">Time Entry Method</h3>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  id="timeEntryToggle"
                  className="toggle-checkbox"
                  checked={timeEntryMethod === "duration"}
                  onChange={(e) =>
                    setTimeEntryMethod(
                      e.target.checked ? "duration" : "from-to"
                    )
                  }
                />
                <label className="toggle-label" htmlFor="timeEntryToggle">
                  <span className="toggle-inner"></span>
                  <span className="toggle-switch"></span>
                </label>
              </div>
              {timeEntryMethod === "from-to" && (
                <div className="from-to-container">
                  {" "}
                  <div className="from-time-container">
                    <h3 className="from" style={{ marginTop: "-3px" }}>
                      From Time
                    </h3>
                    <DatePicker
                      className="timesheet-d-input"
                      selected={selectedFromTime}
                      onChange={handleFromTime}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Select From Time"
                    />{" "}
                  </div>{" "}
                  <div className="to-time-container">
                    <h3 className="to">To Time</h3>
                    <DatePicker
                      className="timesheet-d-input"
                      selected={selectedToTime}
                      onChange={handleToTime}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Select To Time"
                    />{" "}
                  </div>{" "}
                </div>
              )}
              {timeEntryMethod === "duration" && (
                <div className="duration-container">
                  <h3 className="user-name" style={{ marginTop: "5px" }}>
                    Duration (hh:mm)
                  </h3>
                  <input
                    type="text"
                    className="timesheet-d-input"
                    value={durationHours}
                    onChange={(e) => setDurationHours(e.target.value)} // Allow the user to type freely
                    onBlur={(e) =>
                      setDurationHours(normalizePlannedHours(e.target.value))
                    }
                    placeholder="Enter Duration"
                    title="Enter duration"
                  />
                </div>
              )}
              <h3 className="user-name">Note</h3>
              <input
                type="text"
                maxLength={60}
                className="timesheet-d-input"
                value={notes}
                onChange={(e) => setNotes(e.target.value)} // Allow the user to type freely
                placeholder="Enter Note (max 60 characters)"
              />
              {tsCategory !== "NonProductive" && (
                <>
                  <h3 className="bill">Billable?</h3>
                  <div className="radio-container">
                    <label htmlFor="yes" className="radio-label">
                      Yes
                      <input
                        type="radio"
                        id="yes"
                        name="isBillable-input"
                        value="Yes"
                        checked={isBillable === "Yes"}
                        onChange={handleRadioChange}
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                      />
                    </label>

                    <label
                      htmlFor="no"
                      className="radio-label"
                      style={{ marginLeft: "15px" }}
                    >
                      No
                      <input
                        type="radio"
                        id="no"
                        name="isBillable-input"
                        value="No"
                        checked={isBillable === "No"}
                        onChange={handleRadioChange}
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                      />
                    </label>

                    <div
                      className={
                        timeEntryMethod === "duration"
                          ? "remaining-hours"
                          : "remaining-hours-fromto"
                      }
                    >
                      {" "}
                      <p style={{ color: "black", fontSize: "12px" }}>
                        {userExistingHoursInMinutes.length !== 0 &&
                          (userExistingHoursInMinutes &&
                          userExistingHoursInMinutes !== "0:00"
                            ? `Remaining hours for the date ⌛ ${format(
                                new Date(selectedDate),
                                "dd-MM-yyyy"
                              )}: ${userExistingHoursInMinutes} Hrs.`
                            : "You have already booked 8 hours for this date.")}
                      </p>
                    </div>
                    <div>
                      <p
                        className={
                          timeEntryMethod === "duration"
                            ? "cannot-book"
                            : "cannot-book-fromto"
                        }
                      >
                        {error}
                      </p>
                      {isContainsHours && (
                        <p style={{ color: "Red", fontSize: "12px" }}>
                          Kindly contact DC to update the planned hours for this
                          project.
                        </p>
                      )}
                      <p style={{ color: "red", fontSize: "12px" }}>
                        {hours === "00:00" &&
                          "Kindly contact DC to add the planned hours for this variation."}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="btn-container-add-timesheet">
              <button
                className="add-btn"
                onClick={handleAddTimesheet}
                style={{
                  backgroundColor:
                    userExistingHoursInMinutes !== "0:00" &&
                    !isContainsHours &&
                    hours !== "00:00"
                      ? "#6200ee"
                      : "grey",
                }}
                disabled={
                  isContainsHours ||
                  userExistingHoursInMinutes === "0:00" ||
                  hours === "00:00"
                }
              >
                Add
              </button>
              <button onClick={onClosePopUp} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddTimeSheet;
